const BasicDetails = () => {
    return (
        <div className="vision-card">
            <div id="basic">

                <h3 className="table-section-heading">
                    BASIC DETAILS
                </h3>

                <div className="table-section-wrap">
                    <table className="table-section basic-table">

                        <thead>
                            <tr>
                                <th colSpan="4">
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            flexWrap: "wrap",
                                            width: "100%",
                                        }}
                                    >
                                        <span>
                                            BASIC DETAILS
                                        </span>

                                        <div style={{ textAlign: "right" }}>
                                            <div>70314 - NAV JEEVAN MISSION SCHOOL ASHISH NAGAR DEORIA</div>
                                            {/* <div>Date : 22-10-2016</div> */}
                                        </div>
                                    </div>
                                </th>
                            </tr>

                        </thead>

                        <tbody>

                            <tr>
                                <td>SCHOOL NAME</td>
                                <td>NAV JEEVAN MISSION SCHOOL</td>
                                <td>SCHOOL CODE</td>
                                <td>70314</td>
                            </tr>

                            <tr>
                                <td>ADDRESS</td>
                                <td>ASHISH NAGAR, SONUGHAT, DEORIA, U.P. - 274001</td>
                                <td>AFFILIATION CODE</td>
                                <td>2131639</td>
                            </tr>

                            <tr>
                                <td>PRINCIPAL'S EMAIL ID</td>
                                <td>Principal.njms7@gmail.com</td>
                                <td>PRINCIPAL'S RETIREMENT DATE</td>
                                <td>31/03/2038</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S CONTACT NUMBER</td>
                                <td>0000-9889471995</td>
                                <td>SCHOOL'S EMAIL ID</td>
                                <td>njmsdeoria1@gmail.com</td>
                            </tr>

                            <tr>
                                <td>SCHOOL'S WEBSITE</td>
                                <td>www.navjeevandeoria.in</td>
                                <td>SCHOOL'S FAX NUMBER</td>
                                <td>0000000000</td>
                            </tr>

                            <tr>
                                <td>LANDMARK NEAR SCHOOL</td>
                                <td>Sonughat Chauraha</td>
                                <td>YEAR OF ESTABLISHMENT</td>
                                <td>2005</td>
                            </tr>

                            <tr>
                                <td>AFFILIATION VALIDITY UP TO</td>
                                <td>31-03-2028</td>
                                <td>AFFILIATION STATUS</td>
                                <td>PROVISIONAL</td>
                            </tr>

                            <tr>
                                <td>NAME OF THE TRUST / SOCIETY / COMPANY REGISTERED</td>
                                <td>Nav Jeevan Mission Educational Society Deoria</td>
                                <td>REGISTRATION DATE</td>
                                <td>25/11/2010</td>
                            </tr>

                            <tr>
                                <td>SOCIETY REGISTRATION NUMBER</td>
                                <td>02328/2025-26</td>
                                <td>REGISTRATION VALIDITY</td>
                                <td>24/11/2030</td>
                            </tr>

                            <tr>
                                <td>NOC ISSUING AUTHORITY</td>
                                <td>Joint Director of Education Gorakhpur</td>
                                <td>NOC ISSUING DATE</td>
                                <td>06/05/2012</td>
                            </tr>

                            <tr>
                                <td>NO OBJECTION CERTIFICATE</td>
                                <td>VIEW</td>
                                <td>NON PROPRIETY CHARTER AFFIDAVIT</td>
                                <td>VIEW</td>
                            </tr>

                        </tbody>

                    </table>
                </div>

            </div>
        </div>

    );
};

export default BasicDetails;